import { render } from "./notificationForm.vue?vue&type=template&id=53defa1c&scoped=true"
import script from "./notificationForm.vue?vue&type=script&lang=js"
export * from "./notificationForm.vue?vue&type=script&lang=js"

import "./notificationForm.vue?vue&type=style&index=0&id=53defa1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53defa1c"]])

export default __exports__